import React, {useEffect, useState} from 'react';

const RecaptchaComponent = ({ sitekey, onVerify, onExpire }: {sitekey: string, onVerify?: (token: string) => void, onExpire?: ()=>void}) => {
    useEffect(() => {
            //@ts-ignore
            if (window.grecaptcha) {
                //@ts-ignore
                window.grecaptcha.ready(()=>{
                    //@ts-ignore
                    window.grecaptcha.render("recaptcha-container", {
                        'sitekey': sitekey,
                        'callback': handlerVerify,
                        'expired-callback': handlerExpire,
                    });
                });
            }
        //@ts-ignore
    }, [sitekey,window.grecaptcha]);

    const handlerVerify = (token: any) => {
        onVerify?.(token);
    };

    const handlerExpire = () => {
        onExpire?.();
    }

    return (
        <div id="recaptcha-container"></div>
    );
};

export default RecaptchaComponent;
